'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const readBodyClass = () => typeof document !== 'undefined' && document.body.classList.contains('dark');

/**
 * Dark mode reaches this package as a `dark` class on `document.body`, set by the dashboard's
 * next-themes bridge, the SDK's ApplyDarkClass and Storybook's preview decorator. This package
 * depends on none of them, and its Tailwind build declares no `dark` custom variant, so `dark:`
 * utilities resolve through prefers-color-scheme and ignore the app's own toggle. Read the class.
 *
 * Seeded synchronously rather than from the effect so a consumer that configures something
 * imperatively on mount (Monaco's theme) picks the right value on its first mount instead of
 * repainting a frame later.
 */
const useIsDarkMode = () => {
  const $ = _c(2);
  const [isDarkMode, setIsDarkMode] = useState(readBodyClass);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const read = () => setIsDarkMode(readBodyClass());
      read();
      const observer = new MutationObserver(read);
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"]
      });
      return () => observer.disconnect();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isDarkMode;
};
export default useIsDarkMode;